<template>
  <custom-dialog
    :supportTouchmove="true"
    :btn-list="[countDownText]"
    :disabled="count !== 0"
    @close="close"
    @btn-click="choose"
  >
    <div class="protocol-dialog">
      <h2>西安网约车经营风险提示</h2>
      <p>
        为进一步规范西安市网约车行业健康发展，维护市场正常秩序，引导社会资源合理配置，保障行业从业人员合法权益，按照西安市网约车行业“全过程执法、全链条监管、全合规营运百日攻坚行动”工作部署，现对西安市网约车行业经营风险提示如下：
      </p>
      <strong>政策要求：</strong>
      <p>
        根据《西安市网络预约出租汽车经营服务管理暂行办法》有关规定，从事网约车经营人员和车辆，应坚决落实“双证合规”要求，依法分别取得《网络预约出租汽车驾驶员证》《网络预约出租汽车运输证》。未取得合法资质车辆及驾驶员从事网约车营运，均属于违法违规行为，一经查实，将依法进行处罚。
      </p>
      <strong>防范风险：</strong>
      <li>（一）以租代购转嫁经营风险。</li>
      <p>
        部分租赁公司和网约车驾驶员签订“融资租赁”合同，由驾驶员出资，以“租车”名义分期购买指定车型的车辆并开展营运，车辆所有人属于租赁公司，将经营风险转嫁给驾驶员。“融资租赁”合同约定3年期满后，将车辆所有权过户给驾驶员，但是没有提到《网络预约出租汽车运输证》的归属问题。根据《行政许可法》《西安市网络预约出租汽车经营服务管理暂行办法》有关规定，车辆许可不得转让。驾驶员和租赁公司签订的3年融资租赁合同到期后，一旦车辆所有权发生转移，运输证将依法注销，该辆车将不能进行网约车营运。
      </p>
      <li>（二）虚假承诺租赁车辆。</li>
      <p>
        部分网约车运力公司，在车辆未取得《网约车运输证》的情况下，以承诺办理“车证”的方式诱导驾驶员购置、承租车辆，后期不能兑现其承诺。驾驶无《网约车运输证》的车辆从事营运属于违法行为，一经查处，将面临行政处罚，违法成本最终可能由驾驶员承担。
      </p>
      <li>（三）高薪招聘陷阱。</li>
      <p>
        部分网约车运力公司，以“高薪”招聘驾驶员的名义，虚夸在其公司选车从事网约车运营可以给予（获得）较高月薪。实际上诱导驾驶员签订的是租车合同，而非劳动合同或协议。待驾驶员发现无法达到其虚夸的收入状况而准备退车时，其往往以车辆部件磨损、车身有伤痕等各种理由扣除驾驶员保证金，造成驾驶员经济受损。
      </p>
      <li>（四）合同条款欺诈。</li>
      <p>
        部分网约车运力公司，推出所谓的“上班模式”“保底模式”，通过合同约定驾驶员流水收入统一由租赁公司代收代发，司机无权支配流水。一旦租赁公司经营不善，“卷款跑路”，驾驶员的车辆押金及流水面临无法挽回的损失。
      </p>
      <li>（五）层层转租增加经营成本。</li>
      <p>
        部分运力公司自身不购置车辆，而是以中间服务商的名义向驾驶员推销其他网约车运力公司的车辆，赚取中间的租车费用“差价”或“推荐费”。一旦此类中间服务商赚取的利润无法支撑自身的运营，可能“卷款跑路”（驾驶员的押金），而网约车车辆所有人将因无法按期收到租金而收回车辆，导致驾驶员经济受损。
      </p>
      <strong>防范建议：</strong>
      <li>01 深入了解法规政策</li>
      <p>
        深入了解西安市网约车行业具体政策，按照正规途径办理网约车相关证件。目前西安市网约车行业三项许可《网络预约出租汽车经营许可证》《网络预约出租汽车运输证》《网路预约出租汽车驾驶员证》的办理均不收取任何费用，请广大从业人员不要相信任何第三方关于网约车办理相关证件的任何广告宣传及承诺。
      </p>
      <li>02 做好经营风险评估</li>
      <p>
        拟进入行业的驾驶员要深入了解网约车政策。签订合同时，要对所签订的合同条款和自行承担的风险进行详细了解，谨防被口头虚假承诺、高薪高收入所诱导。尽量不选择“以租代购”“融资租赁”等模式，避免产生经济损失。
      </p>
      <li>03 依法依规运营服务</li>
      <p>
        在西安市开展网约车经营服务，应严格遵守《西安市网络预约出租汽车经营服务管理暂行办法》规定，违法违规行为将被依法查处。西安市交通执法部门将重点打击平台向不合规车辆派单、平台不按规定传输数据以及无运输证车辆非法营运等违法违规行为。
      </p>
      <p>
        根据市场调研和行业监测数据显示，西安市出租汽车（含网约车）运力已趋于饱和状态，驾驶员收入较之前下滑幅度较大。随着公共交通体系逐步完善，西安市出租汽车（网约车）运力将更加饱和，进一步影响网约车从业者收益预期。希望有意愿从事网约车经营的人员认真调研市场营收情况，谨慎研判经营风险，切实增强风险防范意识，避免因盲目进入市场、政策了解不全面造成不必要的矛盾纠纷或经济损失。
      </p>

      <p style="text-align:right;">西安市出租汽车管理处</p>
      <p style="text-align:right;">2023年9月26日</p>

      <p></p>
    </div>
  </custom-dialog>
</template>

<script>
import CustomDialog from './custom-dialog'
export default {
  data() {
    return {
      count: 5,
      timer: null,
    }
  },
  components: {
    CustomDialog,
  },
  props: {
    btnText: {
      type: String,
      default: '我已阅读并同意协议',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    countDownText() {
      if (this.count === 0) {
        return `${this.btnText}`
      }
      return `${this.btnText}（${this.count}）`
    },
  },
  methods: {
    choose() {
      this.$emit('agree')
    },
    close() {
      this.$emit('close')
    },
    countDown() {
      this.timer = setTimeout(() => {
        if (this.count === 0 && this.timer) {
          clearTimeout(this.timer)
        } else {
          this.count -= 1
          this.countDown()
        }
      }, 1000)
    },
  },
  mounted() {
    this.countDown()
  },
  beforeDestroy() {
    this.count = 5
  },
}
</script>

<style lang="stylus" scoped>
@import '../styles/variable.styl';

.protocol-dialog {
  h2, h3, h4 {
    text-align: center;
    font-weight: bold;
  }

  h2 {
    font-size: $ucar_font_h4;
    margin: 60px auto;

    &:first-child {
      margin: 0 auto 60px;
    }
  }

  h3 {
    font-size: $ucar_font_h5;
    margin: 40px;
  }

  p {
    font-size: $ucar_font_h6;
    margin-bottom: 1em;
    line-height: 1.5;
    text-indent: 2em;
  }
  strong {
    line-height: 2em;
  }


  ul, ol {
    li {
      font-size: $ucar_font_h6;
      color: $ucar_font_color;
      line-height: 2;
    }
  }

  ul {
    li {
      text-indent: 2em;
    }
  }

  ol {
    & > li {
      font-weight: bold;
      list-style: decimal inside;
    }
  }
}
</style>